window.addEventListener('load', () => {
  const htmlElement = document.documentElement;
  htmlElement.classList.replace('no-js', 'js');
});



// WEBPACK FOOTER //
// ./src/js/remove-no-js.js